/** @flow */
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import ui from 'common/modules/ui/reducers/uiReducer';
import session from '../modules/authentication/reducers/sessionReducer';
import authentication from '../modules/authentication/reducers/authenticationReducer';
import advertiser from '../modules/advertiser/reducers/advertiserReducer';
import userProfile from '../modules/userProfile/reducers/userProfileReducer';
import promotion from '../modules/promotions/reducers/promotionReducer';

import { CLOSE_SESSION } from '../modules/authentication/actions/sessionActions';

const reducers = {
  form,
  ui,
  session,
  authentication,
  advertiser,
  userProfile,
  promotion,
};

export type Reducers = typeof reducers;

const rootReducer = combineReducers(reducers);

const appReducer = (state: any, action: any) => {
  let newState = state;

  if (action.type === CLOSE_SESSION) {
    newState = {
      session: state.session,
      ui: state.ui,
    };
  }

  return rootReducer(newState, action);
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/advertisers/redux/reducers.js